import { useQuery } from '@tanstack/react-query';
import { fetchActiveCountries } from '@/shared/api/places';
import { toOptions } from '@/shared/lib/options';
import { FormModalButton, type EntityField } from '@/shared/ui/list/EntityFormModal';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { fetchCompanies, saveCompany } from './api';

const LIST_KEY = 'insurance-companies';

interface Company extends ListRow {
  id: number;
  name: string;
  country_id?: number;
}

export const CompaniesPage = () => {
  const countries = useQuery({ queryKey: ['active-countries'], queryFn: fetchActiveCountries });

  const fields: EntityField[] = [
    { name: 'name', label: 'Имя страховой', placeholder: 'Название...' },
    { name: 'countryId', label: 'Страна', type: 'select', options: toOptions(countries.data) },
  ];

  const config: ListPageConfig<Company> = {
    queryKey: LIST_KEY,
    title: 'Страховые компании',
    errorText: 'Ошибка загрузки страховых компаний',
    fetchList: fetchCompanies,
    rows: ['data'],
    paginated: false,
    headerActions: (
      <FormModalButton
        buttonLabel="Создать"
        buttonClassName="btn btn-info pull-right"
        title="Создать страховую компанию"
        fields={fields}
        initial={{ name: '', countryId: '' }}
        save={(v) => saveCompany({ name: String(v.name), countryId: String(v.countryId) })}
        listKey={LIST_KEY}
      />
    ),
    columns: [
      { header: 'id страховой', render: (company) => company.id },
      { header: 'Имя страховой', render: (company) => company.name },
      {
        header: 'Edit',
        render: (company) => (
          <FormModalButton
            buttonLabel="Edit"
            title="Редактировать страховую компанию"
            fields={fields}
            initial={{ name: company.name, countryId: String(company.country_id ?? '') }}
            save={(v) =>
              saveCompany({ id: company.id, name: String(v.name), countryId: String(v.countryId) })
            }
            listKey={LIST_KEY}
          />
        ),
      },
    ],
  };

  return <GenericListPage config={config} />;
};
